export const forecastedDividendConstants = {
  FORECASTED_DIVIDEND_CREATE_LOADING: 'FORECASTED_DIVIDEND_CREATE_LOADING',
  FORECASTED_DIVIDEND_CREATE_SUCCESS: 'FORECASTED_DIVIDEND_CREATE_SUCCESS',
  FORECASTED_DIVIDEND_CREATE_FAILURE: 'FORECASTED_DIVIDEND_CREATE_FAILURE',
  FORECASTED_DIVIDEND_ERROR_RELOAD: 'FORECASTED_DIVIDEND_ERROR_RELOAD',

  FORECASTED_DIVIDEND_LIST_LOADING: 'FORECASTED_DIVIDEND_LIST_LOADING',
  FORECASTED_DIVIDEND_LIST_SUCCESS: 'FORECASTED_DIVIDEND_LIST_SUCCESS',
  FORECASTED_DIVIDEND_LIST_FAILURE: 'FORECASTED_DIVIDEND_LIST_FAILURE',

  FORECASTED_DIVIDEND_EDIT_LOADING: 'FORECASTED_DIVIDEND_EDIT_LOADING',
  FORECASTED_DIVIDEND_EDIT_SUCCESS: 'FORECASTED_DIVIDEND_EDIT_SUCCESS',
  FORECASTED_DIVIDEND_EDIT_FAILURE: 'FORECASTED_DIVIDEND_EDIT_FAILURE',

  FORECASTED_DIVIDEND_DELETE_LOADING: 'FORECASTED_DIVIDEND_DELETE_LOADING',
  FORECASTED_DIVIDEND_DELETE_SUCCESS: 'FORECASTED_DIVIDEND_DELETE_SUCCESS',
  FORECASTED_DIVIDEND_DELETE_FAILURE: 'FORECASTED_DIVIDEND_DELETE_FAILURE'
};
